import { configRefs } from '@utils/constants';
import { logger } from './Logger.js';

const cache = /* @__PURE__ */ new Map();
const setAlphaOnRgbColor = (color, alpha) => {
  if (configRefs.env.node.dangerouslyAssertSyncValue() !== "production") {
    if (color.match(/^rgba?\(/i) === null) {
      logger.error(
        "setAlphaOnRgbColor(...): color doesn't look like a rgb color",
        color
      );
    }
    if (alpha < 0 && alpha > 1) {
      logger.error(
        "setAlphaOnRgbColor(): alpha should by a number between 0 and 1",
        color
      );
    }
  }
  const cacheKey = `${color}-${alpha.toString()}`;
  if (!cache.has(cacheKey)) {
    const segments = color.replace(/^rgba?\(/, "").split(",").map((segment) => parseInt(segment, 10)).slice(0, 3);
    const rgb = {
      r: segments[0] ?? 0,
      g: segments[1] ?? 0,
      b: segments[2] ?? 0
    };
    cache.set(
      cacheKey,
      `rgba(${rgb.r.toString()}, ${rgb.g.toString()}, ${rgb.b.toString()}, ${alpha.toString()})`
    );
  }
  return cache.get(cacheKey);
};

export { setAlphaOnRgbColor };
//# sourceMappingURL=setAlphaOnRgbColor.js.map
